/**
 * Générateur de nombres aléatoires injecté dans les moteurs.
 * Retourne un flottant dans [0, 1) — même contrat que `Math.random`.
 */
export type Rng = () => number;

/** RNG seedable déterministe (mulberry32). Un même seed reproduit la même suite. */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** RNG par défaut, basé sur `Math.random` (comportement du prototype v8). */
export const systemRng: Rng = () => Math.random();

/** Entier uniforme dans [0, n) — remplace `R(n)` du prototype. */
export function ri(rng: Rng, n: number): number {
  return Math.floor(rng() * n);
}

/** Mélange Fisher-Yates en place — remplace `shuffle(a)` du prototype. */
export function shuffle<T>(rng: Rng, a: T[]): T[] {
  for (let i = a.length - 1; i > 0; i--) {
    const j = ri(rng, i + 1);
    const t = a[i];
    a[i] = a[j];
    a[j] = t;
  }
  return a;
}
